/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: AlphabeticallistofproductsListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: AlphabeticallistofproductsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { AlphabeticallistofproductsData, AlphabeticallistofproductsService } from './Alphabeticallistofproducts.service';
import { AlphabeticallistofproductsSearchComponent }  from './AlphabeticallistofproductsSearch.component';

@Component({
	selector: 'my-Alphabeticallistofproducts',
	template: require('./AlphabeticallistofproductsList.component.html'),
	providers: [AlphabeticallistofproductsService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class AlphabeticallistofproductsListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	AlphabeticallistofproductsList: AlphabeticallistofproductsData[];
	newAlphabeticallistofproducts: AlphabeticallistofproductsData;
	selectedAlphabeticallistofproducts: AlphabeticallistofproductsData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(AlphabeticallistofproductsSearchComponent) filterComponent: AlphabeticallistofproductsSearchComponent;

	sortExpression: string = "ProductID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private AlphabeticallistofproductsService: AlphabeticallistofproductsService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newAlphabeticallistofproducts = new AlphabeticallistofproductsData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.AlphabeticallistofproductsService.getAll().subscribe(record => this.AlphabeticallistofproductsList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getAlphabeticallistofproductsByPaging();

		/*
		this.AlphabeticallistofproductsList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getAlphabeticallistofproducts() {
		this.AlphabeticallistofproductsService.getAll()
			.subscribe(data => this.AlphabeticallistofproductsList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on AlphabeticallistofproductsSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getAlphabeticallistofproductsByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getAlphabeticallistofproductsByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getAlphabeticallistofproductsByPaging();
	}
	
	// Get records by paging
	getAlphabeticallistofproductsByPaging() {
		this.AlphabeticallistofproductsService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.AlphabeticallistofproductsList=data.AlphabeticallistofproductsList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addAlphabeticallistofproducts() {
		this.AlphabeticallistofproductsService.addAlphabeticallistofproductsData(this.newAlphabeticallistofproducts).subscribe(record => console.log(record));
		this.getAlphabeticallistofproducts();
	}
  
	// Updates existing record
	updateAlphabeticallistofproducts() {
		this.AlphabeticallistofproductsService.updateAlphabeticallistofproductsData(this.selectedAlphabeticallistofproducts).subscribe(record => console.log(record));
		this.getAlphabeticallistofproducts();
	}

	// Deletes record with specified id
	deleteAlphabeticallistofproducts(id: string) {
		if (window.confirm('Are you sure you want to delete this Alphabeticallistofproducts?') == true)
		{
			this.AlphabeticallistofproductsService.deleteAlphabeticallistofproducts(id)
			.subscribe(data => this.getAlphabeticallistofproducts(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getAlphabeticallistofproductsByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getAlphabeticallistofproductsByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getAlphabeticallistofproductsByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getAlphabeticallistofproductsByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: AlphabeticallistofproductsData) {
		this.router.navigate(['/Alphabeticallistofproducts', item.ProductID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: AlphabeticallistofproductsData) {
		this.router.navigate(['/Alphabeticallistofproducts/Details', item.ProductID]);
	}

	// Set record as selected
	SelectAlphabeticallistofproducts(item: AlphabeticallistofproductsData) {
		this.selectedAlphabeticallistofproducts = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: AlphabeticallistofproductsData) {
		return item.ProductID === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Alphabeticallistofproducts/AlphabeticallistofproductsList.component.ts